import React from "react";
import { cn } from "@/lib/utils";
import { ShieldCheck, AlertTriangle, XOctagon } from "lucide-react";

export const confidenceTier = (c) => {
  if (c >= 0.8) return "high";
  if (c >= 0.6) return "low";
  return "critical";
};

const MAP = {
  high: {
    cls: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
    Icon: ShieldCheck,
    label: "High Confidence",
  },
  low: {
    cls: "bg-amber-500/15 text-amber-500 border-amber-500/30",
    Icon: AlertTriangle,
    label: "Low Confidence",
  },
  critical: {
    cls: "bg-red-500/15 text-red-500 border-red-500/30",
    Icon: XOctagon,
    label: "Needs Review",
  },
};

export const ConfidenceBadge = ({ value, showLabel = true, className, testId }) => {
  const tier = confidenceTier(value);
  const { cls, Icon, label } = MAP[tier];
  const pct = Math.round((value || 0) * 100);
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-lg border px-2.5 py-1 text-xs font-medium",
        cls,
        className
      )}
    >
      <Icon className="h-3.5 w-3.5" />
      <span className="font-mono">{pct}%</span>
      {showLabel && <span className="hidden sm:inline">{tier === "high" ? "High" : label}</span>}
    </span>
  );
};

export const ConfidenceBar = ({ value }) => {
  const tier = confidenceTier(value);
  const color =
    tier === "high" ? "bg-emerald-500" : tier === "low" ? "bg-amber-500" : "bg-red-500";
  return (
    <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden">
      <div
        className={cn("h-full rounded-full transition-all duration-500", color)}
        style={{ width: `${Math.round((value || 0) * 100)}%` }}
      />
    </div>
  );
};
